// برنامه‌های بودجه
// همان فرم مشترک طرح/برنامه، با فیلتر برنامه
import React from 'react';
import AccountingProgram from '../Accounting/AccountingProgram';

export default function BudgetProgram({ user, onBack }) {
  return <AccountingProgram user={user} onBack={onBack} initialKind={0} />;
}
